import AxiosConfig from '../config/axiosConfigApiPlataform'

export const PlataformAuthApi = {
  async logout () {
    let response = await AxiosConfig.api().delete('oauth')
    return response.data
  },

  async login (data) {
    let response = await AxiosConfig.api().post('oauth/token', data)
    return response.data
  },

  async socialLogin (data) {
    let response = await AxiosConfig.api().post('social/verify', data)
    return response.data
  },

  async createSocialUser (data) {
    let response = await AxiosConfig.api().post('social/create', data)
    return response.data
  },

}

export default PlataformAuthApi
